import Header from "../Global/Header";

export default function Matic() {
  return (
    <>
      <Header />

      <div className="container stakes">
        <div className="row row_stake">
          <div className="recieve">
            <span className="head_stake"> STAKE $LITTLE & RECIEVE MATIC</span>
            <span>
              <button className="custom-btn btn-banner stake_btn new ">
                STAKE ALL LITTLE
              </button>
            </span>
          </div>
          <div className="col-sm-3 box_list1">
            <div className="box_1 rewards little_box">
              <p>Available $LITTLE</p>
              <p>
                <span>4.500</span>
              </p>
            </div>
          </div>

          <div className="col-sm-3 box_list2">
            <div className="box_2 rewards little_box">
              <p>TOTAL MATIC BALANCE</p>
              <p>
                <span>500</span>
              </p>
            </div>
          </div>
          <div className="col-sm-3 box_list3">
            <div className="box_3 rewards staked_littles little_box">
              <p>STAKED $LITTLE</p>
              <p>
                <span>2.500</span>
              </p>
            </div>
          </div>
          <div className="col-sm-3 box_list4">
            <div className="box_4 rewards little_box">
              <p>MATIC REWARDS PER DAY</p>
              <p>
                <span>25 MATIC</span>
              </p>
            </div>
          </div>
          <div className="hide_btn">
            <button className="custom-btn btn-banner stake_btn new_btn ">
              STAKE ALL LITTLE
            </button>
          </div>

          <div className="col-sm-6">
            <div className="min_little">
              <label>
                <p>Min 2000 $LITTLE</p>
              </label>
              <input className="add_input" type="text" placeholder="ADD $" />
              <span className="input_wrap">
                <button className="staking__btn">STAKE</button>
              </span>
            </div>

            <p></p>
          </div>

          <div className="col-sm-6">
            <div className="min_little little_col">
              <label>
                <p>MATIC</p>
              </label>
              <input className="add_input" type="text" placeholder="0" />
              <span className="input_wrap">
                <button className="staking__btn">WITHDRAWL</button>
              </span>
            </div>

            <p></p>
          </div>
        </div>
      </div>
    </>
  );
}
